import { PageHeader } from "components/common";
import { PageWrapper } from "components/common/pageWrapper/PageWrapper";
import { useQuery, useToggle } from "hooks";
import darkPlusIcon from "assets/images/darkPlus.svg";
import { queryString } from "utilities";
import {
  DrawerHelpers,
  getTablePropsBasedOnDrawerHelpers,
} from "components/utils/drawerHelpers/DrawerHelpers";
import { Table } from "components/miloDesignSystem/molecules/table";
import { mainListUiSchema } from "components/miloDesignSystem/molecules/table/uiSchemas";
import { useRampsColumns } from "./useRampsColumns";
import { AddRampModal } from "./addRampModal/AddRampModal";
import { RightPanel } from "./rightPanel/RightPanel";
import { wmsRampActions } from "api/wms/ramps/actions";
import { RampListItem } from "api/wms/ramps/models";

export const RampsList = () => {
  const { query, updateQuery } = useQuery({ exclude: ["panelId"] });
  const search = queryString.stringify(query);
  const { data: ramps, error, isPreviousData, isLoading, pagination } = wmsRampActions.useGetRamps(
    search,
  );
  const columns = useRampsColumns();
  const addRampModal = useToggle();

  return (
    <>
      <PageWrapper>
        <PageHeader
          searchInput={{
            label: "Szukaj wśród ramp",
            tags: [],
          }}
          createButton={{
            alt: "utwórz",
            disabled: false,
            img: darkPlusIcon,
            label: "Utwórz rampę",
            onClick: addRampModal.open,
          }}
          viewLabel="WMS_RAMPS"
        />
        <div className="d-flex flex-1 overflow-hidden justify-content-between">
          <DrawerHelpers name="wmsRamps">
            {drawerHelpers => (
              <>
                <Table<RampListItem>
                  rows={ramps}
                  columns={columns}
                  onPaginationChange={paginationState => {
                    updateQuery({ ...query, page: paginationState.pageIndex });
                  }}
                  isLoading={isLoading || isPreviousData}
                  error={error}
                  pagination={pagination}
                  uiSchema={mainListUiSchema}
                  {...getTablePropsBasedOnDrawerHelpers(drawerHelpers)}
                />

                <RightPanel />
              </>
            )}
          </DrawerHelpers>
        </div>
      </PageWrapper>
      {addRampModal.isOpen && <AddRampModal close={addRampModal.close} />}
    </>
  );
};
